export class GetAllSchoolYear {
    public static readonly type = '[School year] get all';
}

export class SetCurrentSchoolYear {
    public static readonly type = '[School year] set current';
}
